export default {
  BASE_URL: '/mm/attribute',
  api: [
    {
      name: 'list',
      method: 'GET',
      desc: '获取属性列表',
      path: '/show/List',
      params: {
        pageSize: 25,
        pageNum: 1,
        brandName: '',
        category: '1;2'
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除属性',
      path: '/removeAttribute/{id}',
      params: {
        id: ''
      }
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '获取当前属性详情',
      path: 'currentAttribute/{id}',
      params: {
        id: ''
      }
    },
    {
      name: 'save',
      method: 'POST',
      desc: '保存属性',
      path: 'operate',
      params: {
        id: '',
        attrName: '',
        category: [],
        attrValue: '',
        sortNum: '',
        searchType: 1,
        isManaul: false
      }
    },
    {
      name: 'checkName',
      method: 'GET',
      desc: '检查属性名称是否重复',
      path: '/validate/name',
      params: {
        id: '',
        category: '',
        attrName: ''
      }
    },
    {
      name: 'selectNextSortNum',
      method: 'GET',
      desc: '获取下一个排序号',
      path: '/next/attribute/{category}',
      params: {
        category: ''
      }
    },
    {
      name: 'getAttrSourceType',
      method: 'GET',
      desc: '获取属性值来源列表',
      path: '/getAttrSourceType',
      params: {
        category: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/pm/attr.js